import { Col, Text, Flex, Button, Icon, TextLink } from 'components';
import { FunnelFooter } from 'containers/Funnel/layout';
import { footer } from 'data';
import theme from 'mymoria-ui/styles/theme';
import { css, mq, styled } from 'mymoria-ui/utils';
import CCAgents from './CCAgents';

interface ContinerProps {
  withBackButtonPadding?: boolean;
}

const Container = styled.div<ContinerProps>(
  ({ withBackButtonPadding, theme: { colors } }) => css`
    background: ${colors.footer.background};
    color: ${colors.footer.secondary};

    ${mq({
      padding: [withBackButtonPadding ? '0 1rem 4rem' : '1rem', null, '1rem'],
    })};
  `,
);

const StyledText = styled(Text)(
  ({ theme: { colors } }) => `
    color: ${colors.footer.primary};
  `,
);

const StyledTextLink = styled(TextLink)<{ desktopClickable?: boolean }>(
  ({ desktopClickable, theme: { colors, space } }) => `
    color: ${colors.footer.primary};
    text-decoration: none;
    margin: ${space[2]} 0;
    pointer-events: ${desktopClickable ? 'auto' : 'none'};
    cursor: ${desktopClickable ? 'pointer' : 'default'};

    &:hover, &:focus {
      color: ${colors.footer.primary};
    }
  `,
);

const ICONS = {
  Mail: Icon.Mail,
  Phone: Icon.Phone,
  WhatsApp: Icon.WhatsApp,
};

const StyledButton = styled(Button)`
  width: 100%;
  display: flex;
  align-items: center;
  font-weight: bold;

  ${mq({
    justifyContent: ['flex-start', 'center'],
    padding: ['0 4rem', '0'],
  })};
`;

const renderIcon = (name: keyof typeof ICONS) => {
  const Icon = ICONS[name];
  return <Icon background="transparent" color={theme.colors.primary} width={40} height={40} />;
};

interface FooterProps {
  full?: boolean;
  withBackButtonPadding?: boolean;
}

const Footer = ({ full, withBackButtonPadding }: FooterProps) => (
  <Container id="footer" withBackButtonPadding={withBackButtonPadding}>
    {full && (
      <Flex flexDirection="column" width={1} alignItems="center" px={0} pt={5} pb={0}>
        <Flex justifyContent="space-between" alignItems="center" width={[0.9, null, 0.48]}>
          <CCAgents width={[0.3, 0.25]} px={0} />
          <Col width={[0.65, 0.67]} py={4}>
            <StyledText
              letterSpacing={0.7}
              fontWeight="bold"
              fontSize="large"
              fontFamily="tertiary"
            >
              {footer.contactTitle}
            </StyledText>
            <Col px={0} display={['none', null, 'block']}>
              {footer.contactLinks.map(link => (
                <StyledTextLink
                  key={link.url}
                  href={link.url}
                  target="_blank"
                  desktopClickable={link.desktopClickable}
                >
                  {link.title} {link.content.desktop}
                </StyledTextLink>
              ))}
            </Col>
          </Col>
        </Flex>
        <Col width={0.9} px={0} display={['block', null, 'none']}>
          {footer.contactLinks.map(link => (
            <StyledButton
              key={link.url}
              variant="primary"
              my={2}
              onClick={() => window.open(link.url, '_self')}
            >
              {renderIcon(link.icon as keyof typeof ICONS)}
              {link.content.mobile}
            </StyledButton>
          ))}
        </Col>
      </Flex>
    )}
    <FunnelFooter links={footer.secondaryLinks} copyright={footer.copyright} />
  </Container>
);

export default Footer;
